const contact = {
    title: 'Contate-nos',
    description: 'Junte-se à nossa comunidade para fornecer feedback, pedir ajuda e compartilhar suas ideias com outros desenvolvedores',
    discord: {
        title: 'Canal do Discord',
        description: 'Junte-se ao nosso canal público para conversar com outros desenvolvedores',
        button: 'Entrar',
    },
    github: {
        title: 'GitHub',
        description: 'Crie uma issue e envie no GitHub',
        button: 'Abrir',
    },
    email: {
        title: 'Enviar email',
        description: 'Envie-nos um e-mail para mais informações e ajuda',
        button: 'Enviar',
    },
};
export default contact;
